import React, { useContext, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ProductContext } from "../API";

import { Picker } from "../components/inputs";
import { Status } from "../components/misc";
import {
  ProductPreview,
  EditInfo,
  EditThumbnail,
  EditDemos,
  EditFiles,
} from "../components/products";

export default function EditProductPage() {
  const { productSlug } = useParams();
  const { products } = useContext(ProductContext);
  const product = useMemo(
    () => products?.find((p) => p.slug == productSlug),
    [productSlug, products]
  );

  const [nav, setNav] = useState("info");

  return (
    <div className="container">
      <div className="flex wrap mb-2">
        <h1>Edit Product</h1>
        <Picker
          options={["info", "thumbnail", "demos", "files"]}
          option={nav}
          setOption={setNav}
        />
      </div>
      {!product ? (
        <Status status="Loading" />
      ) : (
        <EditProduct product={product} nav={nav} />
      )}
    </div>
  );
}

function EditProduct({ product, nav }) {
  const navigate = useNavigate();
  function close() {
    navigate("/products");
  }

  const [info, setInfo] = useState({
    ...product,
    release_date: new Date(product.release_date),
  });
  const [thumbnail, setThumbnail] = useState(product.thumbnail.location);
  const [demos, setDemos] = useState(
    product.demos.map((demo) => ({
      name: demo.name,
      audio: demo.location,
    }))
  );
  const [newDemo, setNewDemo] = useState(null);
  const [files, setFiles] = useState(product.products);
  const [newFile, setNewFile] = useState(null);

  return (
    <div className="flex wrap start center">
      <div className="block grow">
        {nav === "info" && (
          <EditInfo info={info} setInfo={setInfo} close={close} />
        )}
        {nav === "thumbnail" && (
          <EditThumbnail
            thumbnail={thumbnail}
            setThumbnail={setThumbnail}
            product={product}
            close={close}
          />
        )}
        {nav === "demos" && (
          <EditDemos
            demos={demos}
            setDemos={setDemos}
            newDemo={newDemo}
            setNewDemo={setNewDemo}
            product={product}
            close={close}
          />
        )}
        {nav === "files" && (
          <EditFiles
            files={files}
            setFiles={setFiles}
            newFile={newFile}
            setNewFile={setNewFile}
            product={product}
            close={close}
          />
        )}
      </div>
      <ProductPreview
        info={info}
        thumbnail={
          typeof thumbnail === "string"
            ? thumbnail
            : URL.createObjectURL(thumbnail)
        }
        demos={newDemo ? [...demos, newDemo] : demos}
        files={newFile ? [...files, newFile] : files}
        className="grow"
      />
    </div>
  );
}
